import {createFileRoute} from '@tanstack/react-router'
import {zeroLevelIndexRoute} from "../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/collection/$username/')({
    ...zeroLevelIndexRoute("/users/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName")
});

